
import { mapGetters } from 'vuex'
import { clone } from '@/utils/enerFunctions'
import ChartContainer from '@/components/page/chartContainer'

export default {
  name: 'CountrySnapshotContent',
  components: { ChartContainer },
  computed: {
    ...mapGetters({
      countrySnapshotStructure: 'countrySnapshotStructure',
      pageContent: 'page/pageContent',
      scenariosContent: 'scenariosContent'
    })
  },
  methods: {
    generateSnapshotConfig (pageChartConfig) {
      const returnedConfig = clone(pageChartConfig)
      returnedConfig.countries = this.pageContent.graph1.countries
      return returnedConfig
    },
    generateChartTitle (title) {
      return this.pageContent.category2 + ' - ' + title
    },
    generateChartFilename (countrySnapshotItem) {
      return 'country-snapshot/' + this.pageContent.category2.toLowerCase() + '-' + countrySnapshotItem.seo.image
    }
  }
}
